var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "绑定展示分类",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.initloading,
                  expression: "initloading",
                },
              ],
              ref: "pram",
              attrs: { model: _vm.pram, "label-width": "90px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "添加分类：", prop: "tagId" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.cateOptions,
                      props: {
                        children: "child",
                        label: "name",
                        value: "id",
                        multiple: true,
                      },
                      clearable: "",
                    },
                    model: {
                      value: _vm.pram.showCategoryIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "showCategoryIds", $$v)
                      },
                      expression: "pram.showCategoryIds",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }